// extracted by mini-css-extract-plugin
module.exports = {"section":"opcoes_section__M_lFu","containerImage":"opcoes_containerImage__ITqtE","image":"opcoes_image__cCQnR"};